import OverlappingTextWithCta from './OverlappingTextWithCTA'

export default OverlappingTextWithCta
